/**
 * @generated SignedSource<<83245c2c3c18853cb7760efd97a3de36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ScheduleCreateFormContainer_Query$variables = {
  siteSlug: string;
};
export type ScheduleCreateFormContainer_QueryVariables = ScheduleCreateFormContainer_Query$variables;
export type ScheduleCreateFormContainer_Query$data = {
  readonly site: {
    readonly owner: {
      readonly id: string;
    };
  };
};
export type ScheduleCreateFormContainer_QueryResponse = ScheduleCreateFormContainer_Query$data;
export type ScheduleCreateFormContainer_Query = {
  variables: ScheduleCreateFormContainer_QueryVariables;
  response: ScheduleCreateFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "siteSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleCreateFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScheduleCreateFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "068619892d2609bc90fb59bb16bbfcd9",
    "id": null,
    "metadata": {},
    "name": "ScheduleCreateFormContainer_Query",
    "operationKind": "query",
    "text": "query ScheduleCreateFormContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    owner {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dfadfd754d5f573c57a6790f6053f4ce";

export default node;
